












































































import Vue from 'vue'
import CreateDialog from '@/components/CreateDialog.vue'
import PasswordField from '@/components/PasswordField.vue'
import { required } from '@/utils/validators'
import { VueForm } from '@/utils/interfaces'
import { updateUser } from '@/api/Users/users.api'

export default Vue.extend({
  components: {
    appCreateDialog: CreateDialog,
    appPasswordField: PasswordField,
  },
  props: {
    value: Boolean,
    uuid: String,
  },
  data() {
    return {
      rules: {
        required: (v: string) =>
          required(v) || this.$t('validation.password.required'),
        identical: () =>
          this.$data.crud.password === this.$data.crud.re_password ||
          this.$t('validation.password.must-match'),
        min: (v: string) =>
          (v && v.length > 7) || this.$t('validation.password.too-short'),
        num: (v: string) => {
          const number = /[0-9]/
          return (
            number.test(v) ||
            this.$t('validation.password.must-contain-numbers')
          )
        },
        letter: (v: string) => {
          const letter = /[a-zA-Z]/
          return (
            letter.test(v) ||
            this.$t('validation.password.must-contain-letters')
          )
        },
      },
      crud: {
        password: '',
        re_password: '',
      },
      loading: false,
      wrongCred: false,
      modified: false,
      errors: {
        password: [],
        re_password: [],
      },
    }
  },
  watch: {
    value(value) {
      if (value) {
        if (this.$refs.form) {
          ;(this.$refs.form as VueForm).reset()
        }
      }
    },
  },
  methods: {
    async onSuccess() {
      this.loading = true
      try {
        await updateUser({ ...this.crud, uuid: this.uuid })
        this.$emit('input', false)
      } catch (error) {
        this.errors = {
          password: [],
          re_password: [],
        }
        this.errors = Object.assign(this.errors, error.response.data)
      } finally {
        this.loading = false
      }
    },
    generatePassword() {
      const password = Math.random()
        .toString(36)
        .slice(-8)
      this.crud.password = password
      this.crud.re_password = password
    },
    async copyText() {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(this.crud.password)
      }
    },
  },
})
